import Vue from 'vue';
import VueRouter from 'vue-router';
import { BASE_URL } from '@/config';
import routes from './routes';
import { applyEvents } from './events';
import { checkPermissionGuard } from '@/guards/check-permission.guard.js';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: BASE_URL,
  routes,
});

//navigation guard to check permissions on every route that has meta-authorization info
router.beforeEach(checkPermissionGuard);

applyEvents(router);

export default router;
